import styles from './DropdownCity.module.css'
import stylesCommon from '../stylesCommon.module.css'
import { useSearchParams } from 'react-router-dom';
import { NavDivMobileBypassHandleCloseMenu } from './MobileMenu';
import { useEffect, useRef, useState } from 'react';
import { ComingSoon } from './ComingSoon';
import { NavBarSiteSearchParamsValues } from './Index';
import { API_V2_USER_PUT } from '../../../api/v2/routes/User';

export const DropdownCity = ({ allowHover = false }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const currentCityId = searchParams.get(NavBarSiteSearchParamsValues.city_id) || 1;
    const [currentCityIndex, setCurrentCityIndex] = useState(0);

    const defaultCityRef = useRef();
    const [state, setState] = useState(false);
    useEffect(() => {
        if (!state) {
            setState(true);
            return;
        }
        if (currentCityId === 1) {
            handleChangeCity(defaultCityRef.current, defaultCityRef.current.value)
        }
    }, [state])

    const quitDropdownRenderRef = useRef();
    const cityList = require('./Cities.json');


    const refSelect = useRef();

    const handleChangeCity = async (e, value) => {
        const select = refSelect.current;
        if (!select) { return }
        const newCityId = parseInt(e?.target?.value || value);
        for (let i = 0; i < cityList.length; i++) {
            const currentIndex = cityList[i];
            if (
                currentIndex.props.value === newCityId &&
                currentIndex.comingSoon) {
                ComingSoon(null, false, 'Em breve atenderemos esta cidade!');
                select.selectedIndex = currentCityIndex;
                return;
            }
        }
        setCurrentCityIndex(select.selectedIndex)

        const newParams = new URLSearchParams(searchParams);
        newParams.set(NavBarSiteSearchParamsValues.city_id, newCityId);
        setSearchParams(newParams);

        //trocando os dados de localização do usuário
        await API_V2_USER_PUT(null, [`id_local=${newCityId}`], null);
        //quando selecionar, para fechar o 'MobileMenu' clica no 'quitDropdownRenderRef' 
        // que não tem a classe bypass: 'NavDivMobileBypassHandleCloseMenu'
        quitDropdownRenderRef?.current?.click();
    }
    const itens = [];
    cityList.map((value, key) => {
        itens.push(
            <option ref={key === 1 ? defaultCityRef : null} className={`${NavDivMobileBypassHandleCloseMenu}`} key={key} {...value.props}>{value.name}</option>
        );
    })


    return <>
        <select
            ref={refSelect}
            className={`${styles.DropdownCity} ${allowHover ? stylesCommon.Hover : ''} ${NavDivMobileBypassHandleCloseMenu}`}
            defaultValue={currentCityId}
            onChange={handleChangeCity}
            id='DropdownCity'
        >{itens}</select>
        {/* Este aqui é só para garantir que vai fechar o dropdown no mobile */}
        <br style={{ display: 'none' }} ref={quitDropdownRenderRef} />
    </>
}